//系统标签
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

import svgWhitepaper from "./Whitepaper.svg";
import svgWebsite from "./Website.svg";
import svgRules from "./Rules.svg";

export default observer(({ data, className }) => {
  const t = useTranslation();
  const { finance } = useStore();

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const convertData = {
      ...data,
    };
    return convertData;
  }, [data]);

  return (
    <div className={cx(styles.main, className)}>
      {!!selfData.whitePaperSite && (
        <a href={selfData.whitePaperSite} target="_blank" rel="noreferrer">
          <img src={svgWhitepaper} />
          <span>{t("finance.whitepaper")}</span>
        </a>
      )}
      {!!selfData.officialSite && (
        <a href={selfData.officialSite} target="_blank" rel="noreferrer">
          <img src={svgWebsite} />
          <span>{t("finance.website")}</span>
        </a>
      )}
      {!!selfData.regulationSite && (
        <a href={selfData.regulationSite} target="_blank" rel="noreferrer">
          <img src={svgRules} />
          <span>{t("finance.rules")}</span>
        </a>
      )}
    </div>
  );
});
